import { Component, ViewChild, AfterViewInit, OnInit, Input} from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';


/** Interface */
import { APs } from '../merakiAps';
/** Meraki API Service */
import { MerakiApiService } from '../meraki-api.service';


@Component({
  selector: 'aplist-component',
  styleUrls: ['./aplist.component.css'],
  templateUrl: './aplist.component.html',
})
export class ApListComponent implements AfterViewInit, OnInit {

  networks = null;
  apsData = null;
  networkName: string = null;
  ModelOnOff: boolean;

  dataSource = new MatTableDataSource<APs>();
  displayedColumns = ['serial', 'name', 'notes'];
  myFilter: string;
  showTable: boolean = false;



  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input()
  public selected: string;

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  redirect(value: string) {
    this.router.navigate(['/ap', value]);
  }
  radioStatus(tags: string) {
    return this.ModelOnOff = tags.match(/radio_off/g) ? false : true;
  }

  selectNetwork(network) {
    console.log(network);
    this.showTable = true;
    this.merakiapi.getDevicelistByNetwork(this.selected).subscribe(data => {
        this.apsData = data;
        this.dataSource.data = this.apsData;

    });
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  constructor(private router: Router, private route: ActivatedRoute, private merakiapi: MerakiApiService) {
    /** Load the AP Data */

    merakiapi.getNetworkList().subscribe(data => {
      this.networks = data;
    });
  }


  ngOnInit(): void {
  }


  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
